import { Button, Dialog, Stack, Typography, useTheme } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import colors from 'styles/colors'
import { MOBILE_XS } from 'utils/constants'

const UnavoidableConfirmCancel = ({
  open,
  title,
  subtitle = '',
  lowFocusText,
  highFocusText,
  lowFocusAction,
  highFocusAction,
  textAlignment = 'left',
  dialogWidth = 'initial',
  hideLowFocus = false,
  hideHighFocus = false,
  isPublicRolePlay = false,
  warning = false
}) => {
  const theme = useTheme()

  const dialogStyles = {
    '& .MuiDialog-paper': {
      width: dialogWidth,
      backgroundColor:
        theme.palette.background.yellow || theme.palette.background.paper,
      padding: !isPublicRolePlay ? 12 : 24
    }
  }

  return (
    <Dialog open={open} sx={dialogStyles}>
      <Stack spacing={12} padding={0}>
        <Stack spacing={4} padding={0} textAlign={textAlignment}>
          <Typography
            variant='h4'
            sx={[
              isPublicRolePlay ? theme.publicRolePlay.result.heading : {},
              {
                color: warning ? colors.Watermelon400 : undefined
              }
            ]}>
            {title}
          </Typography>
          <Typography
            sx={[
              isPublicRolePlay ? theme.publicRolePlay.result.description : {}
            ]}>
            {subtitle}
          </Typography>
        </Stack>
        <RowStack
          spacing={4}
          justifyContent='center'
          sx={{ [MOBILE_XS]: { flexDirection: 'column', gap: 4 } }}>
          {!hideLowFocus && (
            <Button
              size={!isPublicRolePlay ? 'small' : 'large'}
              onClick={lowFocusAction}
              variant={!isPublicRolePlay ? 'contained' : 'outlined'}
              color='muted'
              sx={[
                warning && {
                  border: `1px solid ${colors.Watermelon400}`,
                  color: colors.Watermelon400
                }
              ]}>
              {lowFocusText}
            </Button>
          )}
          {!hideHighFocus && (
            <Button
              size={!isPublicRolePlay ? 'small' : 'large'}
              onClick={highFocusAction}
              sx={[
                warning && {
                  backgroundColor: colors.Watermelon400,
                  color: colors.White,
                  '&:hover': {
                    backgroundColor: colors.Watermelon400
                  }
                }
              ]}>
              {highFocusText}
            </Button>
          )}
        </RowStack>
      </Stack>
    </Dialog>
  )
}

export default UnavoidableConfirmCancel
